import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { PolicyContainer } from '../common/PolicyContainer';

export const Privacy: FC = () => {
  const { t } = useTranslation('common');

  return (
    <PolicyContainer>
      <h1>{t('footer.links.privacy')}</h1>
      <h2>INTRODUCTION</h2>
      <p>
        LEAD GATES LTD and its group of companies and affiliates under the &quot;Smart Gates&quot; brand (hereinafter
        referred to as &quot;Smart Gates&quot; or &quot;we&quot;) understand that you are aware of and care about the
        protection of your personal data, and we take this seriously. This Privacy Policy describes the policies and
        practices regarding the collection and use of your personal data by us, as well as establishes your rights to
        privacy. We recognize that that the protection of personal data is an ongoing responsibility and we may update
        this Privacy Policy from time to time as we apply new methods of processing personal data. We are fully
        committed to ensuring that our personal data processing practices comply with Art. 13 and Art. 14 of Regulation
        (EU) 2016/679 of the EP and of the Council of 27 April 2016 on the protection of natural persons with regard to
        the processing of personal data and on the free movement of such data (General Data Protection Regulation -
        GDPR).
      </p>
      <h2>INFORMATION WE MAY COLLECT FROM YOU</h2>

      <h3>Personal data:</h3>
      <h4>We may collect and process the following personal data about you:</h4>
      <ul>
        <li>
          <p>
            Information and documentation that you provide to us for registration. Such information may include, but is
            not limited to, Company name, Company website, Registration number, Registration data, Registered address,
            Busines address, Phone number, Email, Telegram, WhatsApp.
          </p>
        </li>
        <li>
          <p>
            Such a record may include your first name, last name, e-mail address, telephone number, company name and
            other personal data that you may disclose to us during such communication;
          </p>
        </li>
        <li>
          <p>
            If you have been granted access to the Client Interface – information about your visits, including but not
            limited to location data, web logs, other communication data and resources that you access;
          </p>
        </li>
        <li>
          <p>
            Information about you as a Customer that we receive from other sources, including but not limited to our
            business partners, service providers and subcontractors.
          </p>
        </li>
      </ul>

      <h3>Other data:</h3>
      <p>
        We may also collect non-personal information about you that does not identify you as a specific person. Such
        non-personal information we may collect includes:
      </p>
      <ul>
        <li>
          <p>
            Browser and device data, such as IP address, operating system and browser type. This is statistical data on
            the activities and browsing patterns of the Website and does not identify any person;
          </p>
        </li>
        <li>
          <p>
            Cookie data, such as time spent on the Website, pages visited, language preferences and other anonymous
            traffic data;
          </p>
        </li>
        <li>
          <p>Company data, such as company name, product and service offerings, jurisdiction.</p>
        </li>
      </ul>

      <h2>HOW WE USE PERSONAL DATA</h2>
      <p>
        We use your personal data in order to provide you with our services/products and to enter into contracts and
        fulfill our contractual obligations accordingly. In this regard, we rely on the contract concluded by you and
        Smart Gates as a valid basis for processing your personal data.
      </p>
      <p>
        We use your personal data to allow you, as a Customer, to use our services/ products. In this regard, we rely on
        the legitimate interests we pursue.
      </p>

      <p>
        We are also required by law to carry out various activities at all times to prevent fraud, money laundering and
        terrorist financing, as well as to comply with other legal obligations. In this regard, we rely on the need to
        comply with a legal obligation as a legitimate basis for processing your personal data.
      </p>
      <p>
        In addition, we process personal data for the purpose of carrying out various marketing activities and in this
        regard we rely on your consent as a valid basis for processing your personal data.
      </p>
      <p>Examples of how we may use your personal data include:</p>
      <ul>
        <li>to provide you with information, products or services requested from us;</li>
        <li>
          to provide you with information that we believe may be of interest to you, provided that you have consented to
          be contacted for such purposes;
        </li>
        <li>to notify you of changes to our products or services;</li>
        <li>
          to ensure that content from the Website is presented in the most effective manner and to ensure the security
          of our Website;
        </li>
        <li>to allow you to use interactive features of our Website;</li>
        <li>to administer our Website;</li>
        <li>to verify your identity in order to comply with legal/regulatory requirements;</li>
        <li>monitor any possible risks of fraud, money laundering, terrorist financing or crime;</li>
        <li>respond to your inquiries and provide customer support;</li>
        <li>conduct marketing research and carry out marketing activities.</li>
      </ul>

      <h2>HOW LONG WE WILL KEEP YOUR PERSONAL DATA</h2>
      <p>
        We will retain your personal data for the period necessary to achieve the purposes listed above, unless a longer
        retention period is required or permitted by law. Please keep in mind that we may be required to retain your
        personal data for various legal or regulatory reasons, such as to ensure proper processing, settlement, refund
        or refund for transactions, as well as to investigate any potential fraud and to comply with anti-money
        laundering and terrorist financing laws and other legal requirements. This means that in the event that you,
        stop using our services, we will still store certain personal data to comply with our legal obligations.
      </p>

      <h2>USE OF SERVICES BY MINORS</h2>
      <p>
        The services/products we provide are not intended for persons under the age of sixteen, and we kindly ask such
        persons not to disclose their personal data to us.
      </p>

      <h2>HOW WE DISCLOSE PERSONAL DATA</h2>
      <p>
        Under certain circumstances, we may disclose the personal data we have collected about you to the following
        categories of recipients:
      </p>
      <ul>
        <li>
          <p>
            <strong>Third Party Financial Institutions.</strong> This may include card organizations, payment systems
            and credit and financial institutions where you maintain your payment account or any other type of account;
          </p>
        </li>
        <li>
          <p>
            <strong>Credit and reference agencies.</strong> We may share personal data with credit reference agencies to
            conduct credit checks and obtain credit reports;
          </p>
        </li>

        <li>
          <p>
            <strong>Third Party Service Providers.</strong> We disclose personal data to service providers only when it
            is necessary to ensure the provision of our services.
          </p>
        </li>

        <li>
          <p>
            <strong>Third Parties in Relation to Business Transfers.</strong> For example, if we sell a business or
            assets or merge with another business entity, we may need to disclose personal data to potential business
            owners or partners.
          </p>
        </li>

        <li>
          <p>
            <strong>Third parties with respect to a legal obligation</strong> or where permitted by law. In certain
            circumstances, we may be required to disclose or share your personal data with auditors, regulators or law
            enforcement agencies in order to comply with a legal obligation. We may also disclose personal data, where
            permitted by law, to enforce or enforce the TERMS OF USE OF THE WEBSITE or other agreements, or to protect
            our rights, property, customers or others.
          </p>
        </li>
      </ul>

      <p>
        Your personal data may be transferred to and processed at a destination outside the European Economic Area
        (&quot;EEA&quot;). It may also be processed by personnel working outside the EEA who work for us or one of our
        service providers. In the event of such a transfer of personal data, we have entered into either Standard
        Contractual Clauses or other appropriate safeguards to ensure that your personal data is processed in a secure
        manner and in accordance with this Privacy Policy.
      </p>

      <h2>YOUR RIGHTS</h2>
      <p>You have certain rights in relation to how we process your personal data:</p>
      <ul>
        <li>
          <p>
            You have the right to <strong>access</strong> your personal data and to receive information about your
            personal data that we process. You can do this by logging into your customer interface account or by
            contacting us at the support@smart-gates.net;
          </p>
        </li>
        <li>
          <p>
            You have the right <strong>to correct the</strong> information we hold about you if it is inaccurate, and
            you may do so by logging into your customer interface account or by contacting us at
            support@smart-gates.net;
          </p>
        </li>

        <li>
          <p>
            You have the right <strong>to object to the</strong> processing of your personal data;
          </p>
        </li>
        <li>
          <p>
            You have the right <strong>to withdraw your consent</strong> to the processing of your personal data for
            marketing purposes. We will inform you (prior to the collection of your data) if we intend to use your data
            for such purposes or if we intend to disclose your information to any third party for such purposes;
          </p>
        </li>
        <li>
          <p>
            You can also ask us to <strong>delete</strong> your personal data or stop processing your personal data.
            However, please note that this right may be subject to certain exceptions. Namely, in situations where we
            are legally obliged to store your personal data, we will not be able to comply with your request, in which
            case we will inform you about it;
          </p>
        </li>
        <li>
          <p>
            You may also ask us <strong>to provide you with</strong> your personal data or <strong>to transfer</strong>{' '}
            it directly to another controller, and we will comply with such a request, provided that the processing of
            personal data previously carried out by us was based on your consent or was necessary for the performance of
            the contract and when it is technically feasible;
          </p>
        </li>
        <li>
          <p>
            You have the right <strong>to lodge a complaint</strong> with the Information Commissioners if you believe
            that we have not complied with the requirements of the General Data Protection Regulation in relation to
            your personal data.
          </p>
        </li>
      </ul>
      <h2>COOKIES</h2>
      <p>
        The Website uses cookies to distinguish you from other Visitors to the Website. This helps to provide you with a
        good browsing experience and also allows us to improve the Website.
      </p>
      <h2>SECURITY</h2>
      <p>
        All information provided by you to us is stored on secure servers and we use appropriate organizational,
        technical and administrative measures to protect your personal data. Once your information is received, we use
        strict procedures and security features to prevent any unauthorized access.
      </p>

      <p>
        However, please note that no transmission of information over the Internet is completely secure, and no storage
        system is guaranteed to be completely secure. If you have reason to believe that your interaction with us is no
        longer secure, please contact us immediately.
      </p>

      <h2>CHANGES TO THIS PRIVACY POLICY</h2>
      <p>
        We may change or update this Privacy Policy. Any changes we may make to this Privacy Policy in the future will
        be posted on the Website, and any such changes will take effect from the date we post the revised Privacy
        Policy.
      </p>
      <p>We may provide you with notices of changes to the Privacy Policy by posting them on our Website.</p>

      <h2>CONTACT</h2>
      <p>
        If you would like to contact us about this Privacy Policy, please use the email address support@smart-gates.net
      </p>
    </PolicyContainer>
  );
};
